import { render, staticRenderFns } from "./MatchContent.vue?vue&type=template&id=204d447e"
import script from "./MatchContent.vue?vue&type=script&lang=js"
export * from "./MatchContent.vue?vue&type=script&lang=js"
import style0 from "./MatchContent.vue?vue&type=style&index=0&id=204d447e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports